import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "tippy.js/dist/tippy.css";
import "./index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import firebase from "firebase";

firebase.initializeApp({
  apiKey: "AIzaSyCeZTpZYcsXG7ngflf0sThHz_5SOoRFL9A",
  authDomain: "young-coderz.firebaseapp.com",
  projectId: "young-coderz",
  storageBucket: "young-coderz.appspot.com",
  messagingSenderId: "1068230905975",
  appId: "1:1068230905975:web:8b69b1191fcbfcefc8b672",
  measurementId: "G-ZT36J9KQDG",
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
